// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const BusinessNameLogs = t.struct({
    businessName1: t.String,
    businessName2: t.String,
    dbaName: t.String,
    modifiedBy: t.String,
    timeStamp: t.String,
    remark: t.String
}, {
    defaultProps: {
        businessName1: '',
        businessName2: '',
        dbaName: '',
        modifiedBy: '',
        timeStamp: '',
        remark: ''
    },
    name: 'BusinessNameLogs',
    strict: true
});
